import { render, staticRenderFns } from "./purchasegnoreList.vue?vue&type=template&id=08742284&scoped=true"
import script from "./purchasegnoreList.vue?vue&type=script&lang=js"
export * from "./purchasegnoreList.vue?vue&type=script&lang=js"
import style0 from "./purchasegnoreList.vue?vue&type=style&index=0&id=08742284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08742284",
  null
  
)

export default component.exports